<template><div></div></template>

<script>
import { routeManager } from "@/services/utilities/route-manager";

export default {
  name: "RedirectedRoute",
  data() {
    return {
      domainToRedirect: ["studea.ensuplr.fr"],
    };
  },
  mounted() {
    const route = new URL(this.$route.query.from);
    if (route.pathname.includes("sl")) {
      this.getMagicLinkRedirectedRoute(route);
    } else {
      this.getRegistrationRedirectedRoute(route);
    }
  },
  methods: {
    getRegistrationRedirectedRoute(route) {
      if (this.domainToRedirect.includes(route.hostname)) {
        let targetDomain;
        switch (route.hostname) {
          case "studea.ensuplr.fr":
            targetDomain = "ensuplr-inscription.studea.fr";
            break;
        }
        window.location.href = "https://" + targetDomain + route.pathname;
      } else {
        this.$router.push({ name: "Error" });
      }
    },

    getMagicLinkRedirectedRoute(route) {
      const cryptedId = route.pathname.substring(4);
      routeManager.getMagicLinkFromV2(cryptedId).then((res) => {
        if (res && res.redirectLink) {
          window.location.href = res.redirectLink;
        } else {
          this.$router.push({ name: "Error" });
        }
      });
    },
  },
};
</script>

<style lang="scss" scoped></style>
